import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {OrderState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class OrderQuery extends QueryEntity<OrderState> {

  constructor(protected store: Store) {
    super(store);
  }

}
